/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthPhoneControllerSendCodeByPhoneMutationRequest,
  TelegramAuthPhoneControllerSendCodeByPhoneMutationResponse,
  TelegramAuthPhoneControllerSendCodeByPhone400,
  TelegramAuthPhoneControllerSendCodeByPhone401,
  TelegramAuthPhoneControllerSendCodeByPhone403,
  TelegramAuthPhoneControllerSendCodeByPhone429,
} from '../../types/TelegramAuthPhoneControllerSendCodeByPhone.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthPhoneSendCodeByPhone } from '../../methods/telegramAuthPhoneSendCodeByPhone.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthPhoneSendCodeByPhoneMutationKey = () =>
  [{ url: '/api/telegram/auth/phone/send-code' }] as const;

export type TelegramAuthPhoneSendCodeByPhoneMutationKey = ReturnType<
  typeof telegramAuthPhoneSendCodeByPhoneMutationKey
>;

/**
 * {@link /api/telegram/auth/phone/send-code}
 */
export function useTelegramAuthPhoneSendCodeByPhone<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthPhoneControllerSendCodeByPhoneMutationResponse,
      ResponseErrorConfig<
        | TelegramAuthPhoneControllerSendCodeByPhone400
        | TelegramAuthPhoneControllerSendCodeByPhone401
        | TelegramAuthPhoneControllerSendCodeByPhone403
        | TelegramAuthPhoneControllerSendCodeByPhone429
      >,
      { data: TelegramAuthPhoneControllerSendCodeByPhoneMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthPhoneControllerSendCodeByPhoneMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthPhoneSendCodeByPhoneMutationKey();

  return useMutation<
    TelegramAuthPhoneControllerSendCodeByPhoneMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthPhoneControllerSendCodeByPhone400
      | TelegramAuthPhoneControllerSendCodeByPhone401
      | TelegramAuthPhoneControllerSendCodeByPhone403
      | TelegramAuthPhoneControllerSendCodeByPhone429
    >,
    { data: TelegramAuthPhoneControllerSendCodeByPhoneMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthPhoneSendCodeByPhone(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
